import { render, staticRenderFns } from "./RevTrends.vue?vue&type=template&id=38162c56"
import script from "./RevTrends.vue?vue&type=script&lang=js"
export * from "./RevTrends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports